import { InteractDiffQuotPoints } from "../../../../content/wiskunde/1g_fx/rico/drawings";
import { RicoTweePunten, RicoGrafiek } from "../../../../content/wiskunde/1g_fx/rico/exercises";
import * as React from 'react';
export default {
  InteractDiffQuotPoints,
  RicoTweePunten,
  RicoGrafiek,
  React
};